import React from 'react'
import { Typography } from '@mui/material'

const SignInMessage = ({ text, color = 'black', sx }) => {
  return (
    <Typography
      variant='body1'
      color={color}
      sx={{
        marginBottom: 4,
        fontFamily: 'Work Sans',
        fontSize: '18px',
        fontWeight: 500,
        lineHeight: '23.46px',
        textAlign: 'center',
        ...sx,
      }}>
      {text}
    </Typography>
  )
}

export default SignInMessage
